import React, { useState} from "react";
import { useNavigate } from "react-router-dom"; // Import useNavigate
import "../styles/LearnerDashboard.css";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import LearnerFeedback from "../components/LearnerFeedback";
import home from "../images/home.png"; // Icons for sidebar
import feedback from "../images/feedback.png";
import tutorials from "../images/tutorials.png";
import history from "../images/history.png";

const LearnerFeedbackPage = () => {
  const [activeItem, setActiveItem] = useState("feedback");
  const [isVideoMode, setIsVideoMode] = useState(true);
  const [searchQuery, setSearchQuery] = useState(''); // Store search query
  const navigate = useNavigate(); // Initialize useNavigate

  const resetSearch = () => {
    setSearchQuery(""); // Reset the search query
  };

  const learnerMenuItems = [
    { icon: home, label: "Home", key: "home" },
    { icon: feedback, label: "Feedback", key: "feedback" },
    { icon: tutorials, label: "Tutorials", key: "tutorials", disabled: true},
    { icon: history, label: "History", key: "history", disabled: true },
  ];

  const getHeaderVisibility = () => {
    if (activeItem === "home" || activeItem === "") {
      return { showSearch: true, showToggle: true, showUserProfile: true };
    } else if (activeItem === "feedback") {
      return { showSearch: false, showToggle: false, showUserProfile: true };
    } else if (activeItem === "tutorials") {
      return { showSearch: true, showToggle: false, showUserProfile: true };
    }
    return { showSearch: false, showToggle: false, showUserProfile: true };
  };
  
  const toggleMode = (mode) => {
    setIsVideoMode(mode);
  };

  // Reset search when switching tabs

  const handleActiveItemChange = (item) => {
    setActiveItem(item); // Update active item

    // Navigate to the correct route
    if (item === "feedback") {
      navigate("/learner/feedback"); // Navigate to feedback page
    } else if (item === "home") {
      navigate("/learner"); // Navigate to home page
    }

    resetSearch(); // Reset search whenever a new section is selected
  };
  // Fetching the current visibility for the header components
  const { showSearch, showToggle, showUserProfile } = getHeaderVisibility();

  return (
    <div className="dashboard">
      <Header
        isVideoMode={isVideoMode}
        toggleMode={toggleMode}
        showSearch={showSearch}
        showToggle={showToggle}
        showUserProfile={showUserProfile}
        searchQuery={searchQuery} // Pass the searchQuery to Header
      
      />
      <main className="main-content">
        <Sidebar
          activeItem={activeItem} // Highlight the correct active item
          setActiveItem={handleActiveItemChange} // Change active item when clicked
          menuItems={learnerMenuItems}
          resetSearch={resetSearch} // Reset search when switching tabs
        />

        <div className="content">
            <div className="feedback-form">
             <LearnerFeedback />
            </div>
        </div>
      </main>
    </div>
  );
};

export default LearnerFeedbackPage;
